import { IScoreReference } from "../../../../common/types";
import { PlanActionTypes } from "../models/planActions";
import { EDIT_PLAN_SCORE } from "../types";

export default (data: IScoreReference): PlanActionTypes => ({
    type: EDIT_PLAN_SCORE,
    payload: data,
});
